import { Switch } from 'react-router-dom';

import SignIn from '../pages/SignIn/SignIn';
import SelectClient from '../pages/SelectClient';
import CadClient from '../pages/CadClient';
import Produtos from '../pages/Produtos';
import Finalizar from '../pages/Finalizar';
import Pedidos from '../pages/Pedidos';

import Route from './Route';

const Routes: React.FC = () => (
	<Switch>
		<Route path="/" exact component={SignIn} />

		<Route path="/client" exact component={SelectClient} isPrivate />
		<Route path="/client/cad" exact component={CadClient} isPrivate />

		<Route path="/products" exact component={Produtos} isPrivate />

		<Route path="/finaly" exact component={Finalizar} isPrivate />

		<Route path="/sales" exact component={Pedidos} isPrivate />
	</Switch>
);

export default Routes;

// <Route path="/products" exact component={ProdutosAux} isPrivate />
